<ion-row>
  <ion-col
    size="4"
    size-xs="12"
    size-md="4"
    size-lg="4"
    style="padding-right: 16px"
  >
    <div class="device-icon-box">
      <ion-icon name="settings-outline" class="device-main-icon"></ion-icon>
      <span class="device-type-label">{{ data().type }}</span>
    </div>
  </ion-col>
  <ion-col
    size="8"
    size-xs="12"
    size-md="8"
    size-lg="8"
    class="text-dark"
    style="padding-right: 16px"
  >
    <ion-row>
      <ion-col>
        <ion-label class="panel-header-text" color="dark">
          {{ 'device_infoTitle' | translate }}
        </ion-label>
      </ion-col>
    </ion-row>
    @if (isAccessExpired()) {
      <ion-row>
        <ion-col>
          <admin-core-lib-installation-no-access>
          </admin-core-lib-installation-no-access>
        </ion-col>
      </ion-row>
    } @else if (isCtdLimitReached()) {
      <ion-row>
        <ion-col>
          <admin-core-lib-installation-ctd-limit>
          </admin-core-lib-installation-ctd-limit>
        </ion-col>
      </ion-row>
    }

    <ion-row class="ion-padding-top">
      <ion-col size="4" class="spec-label">{{
        'device_serialNumber' | translate
      }}</ion-col>
      <ion-col size="8" class="spec-value">{{ data().sn }}</ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4" class="spec-label">{{
        'list_type' | translate
      }}</ion-col>
      <ion-col size="8" class="spec-value">{{ data().type }}</ion-col>
    </ion-row>
  </ion-col>
</ion-row>
